const jdkToName = {
	// 日常玩法-签到赢好礼
	1: '签到赢好礼',
	// 日常玩法-每日限时抢
	3: '每日限时抢',
	// 日常玩法-关注店铺有礼
	4: '关注店铺有礼',
	// 日常玩法-完善信息有礼
	7: '完善信息有礼',
	// 日常玩法-天降红包雨
	22: '天降红包雨',
	// 无线营销-开卡礼包
	13: '开卡礼包',
	// 无线营销-店铺礼包
	14: '店铺礼包',
	// 无线营销-店铺礼包（千人千面）
	15: '店铺礼包（千人千面）',
	// 无线营销-预售有礼
	27: '预售有礼',
	// 无线营销-预售抽奖
	28: '预售抽奖',
	// 无线营销-首购有礼
	17: '首购有礼',
	// 无线营销-复购有礼
	18: '复购有礼',
	// 无线营销-评价有礼
	20: '评价有礼',
	// 无线营销-下单有礼
	16: '下单有礼',
	// 无线营销-下单抽奖
	19: '下单抽奖',
	// 裂变营销-邀请开卡有礼
	5: '邀请开卡有礼',
	// 裂变营销-邀请关注有礼
	6: '邀请关注有礼',
	// 裂变营销-裂变神券
	21: '裂变神券',
	// 裂变营销-超级裂变券
	31: '超级裂变券',
	// 趣味抽奖-大转盘抽奖
	8: '大转盘抽奖',
	// 游戏中心-天降红包雨
	22: '天降红包雨',
	// 游戏中心-欢乐娃娃机
	23: '欢乐娃娃机',
	// 游戏中心-大家来找茬
	24: '大家来找茬',
	// 小部件管理-智能活动海报
	25: '智能活动海报',
	// 小部件管理-刮刮乐
	26: '刮刮乐',
	// 小部件管理-会员卡片
	32: '会员卡片',
	// 小部件管理-0元试用
	33: '0元试用',
	// 会员商城-积分兑换优惠券
	10: '积分兑换优惠券',
	// 会员商城-积分兑换实物
	9: '积分兑换实物',
	// 会员商城-积分兑换京豆
	29: '积分兑换京豆',
	// 会员商城-积分兑换E卡
	30: '积分兑换E卡',
}

export default jdkToName